export default "__VITE_ASSET__a5niCj0g__"